import { FC, useEffect, useState } from 'react';
import { Box, Progress } from '@robocorp/components';
import { useTranslation } from 'react-i18next';

type Props = {
  height?: number;
  /**
   * Is the loader used as initial, fullscreen application loading indicator
   */
  initial?: boolean;
  /**
   * Delay in seconds of the loader render
   */
  delay?: number;
};

/**
 * Full page loading placeholder for when no other content is available to display yet
 */
const ViewLoader: FC<Props> = ({ delay, height, initial }) => {
  const { t } = useTranslation();
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setReady(true);
    }, 800);

    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  if (delay && !ready) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={height || '100%'}
      maxWidth={480}
      margin="0 auto"
      data-testid={initial ? 'root-loader' : 'loader'}
    >
      <Progress variant={initial ? 'fullscreen' : 'linear'} />
      {initial && (
        <Box mt={48} color="grey30">
          {t('loadingControlRoom')}...
        </Box>
      )}
    </Box>
  );
};

export default ViewLoader;
